import {createAction, createActionFetch} from '../../common/util/redux';
import {IComment, ICommentLikeStatus, ICommentSort, ReportType} from '../type';

export enum ActionType {
  FetchEpisodeComments = 'comment.FetchEpisodeComments',
  AddEpisodeComments = 'comment.AddEpisodeComments',
  FetchEpisodeReplyComments = 'comment.FetchEpisodeReplyComments',
  AddEpisodeReplyComments = 'comment.AddEpisodeReplyComments',
  SetEpisodeReplyOpen = 'comment.SetEpisodeReplyOpen',
  FetchEpisodeLikeStatus = 'comment.FetchEpisodeLikeStatus',
  SetEpisodeLikeStatus = 'comment.SetEpisodeLikeStatus',
  FetchDeleteEpisodeComment = 'comment.FetchDeleteEpisodeComment',
  DeleteEpisodeComment = 'comment.DeleteEpisodeComment',
  FetchPostEpisodeComment = 'comment.FetchPostEpisodeComment',
  FetchPostEpisodeReplyComment = 'comment.FetchPostEpisodeReplyComment',
  SetEpisodeCommentSort = 'comment.SetEpisodeCommentSort',

  FetchContentComments = 'comment.FetchContentComments',
  AddContentComments = 'comment.AddContentComments',
  FetchContentReplyComments = 'comment.FetchContentReplyComments',
  AddContentReplyComments = 'comment.AddContentReplyComments',
  SetContentReplyOpen = 'comment.SetContentReplyOpen',
  FetchContentLikeStatus = 'comment.FetchContentLikeStatus',
  SetContentLikeStatus = 'comment.SetContentLikeStatus',
  FetchDeleteContentComment = 'comment.FetchDeleteContentComment',
  DeleteContentComment = 'comment.DeleteContentComment',
  SetContentCommentSort = 'comment.SetContentCommentSort',

  FetchEventComments = 'comment.FetchEventComments',
  AddEventComments = 'comment.AddEventComments',
  FetchEventReplyComments = 'comment.FetchEventReplyComments',
  AddEventReplyComments = 'comment.AddEventReplyComments',
  SetEventReplyOpen = 'comment.SetEventReplyOpen',
  FetchEventLikeStatus = 'comment.FetchEventLikeStatus',
  SetEventLikeStatus = 'comment.SetEventLikeStatus',
  FetchDeleteEventComment = 'comment.FetchDeleteEventComment',
  DeleteEventComment = 'comment.DeleteEventComment',
  FetchPostEventComment = 'comment.FetchPostEventComment',
  FetchPostEventReplyComment = 'comment.FetchPostEventReplyComment',
  SetEventCommentSort = 'comment.SetEventCommentSort',

  FetchReportComment = 'comment.FetchReportComment',
  FetchBlockWriter = 'comment.FetchBlockWriter',
  FetchUnBlockWriter = 'comment.FetchUnBlockWriter',
  SetWriterBlock = 'comment.SetWriterBlock',
}

export const actions = {
  fetchEpisodeComments: (
    payload: {
      episodeId: number;
      sort: ICommentSort;
    },
    isFirst?: boolean
  ) =>
    createActionFetch(ActionType.FetchEpisodeComments, {
      payload,
      fetchKey: payload.episodeId,
      isFirst,
    }),
  addEpisodeComments: (data: {
    comments: IComment[];
    isFirst?: boolean;
    sort: ICommentSort;
  }) => createAction(ActionType.AddEpisodeComments, data),
  fetchEpisodeReplyComments: (parentId: number, isFirst?: boolean) =>
    createActionFetch(ActionType.FetchEpisodeReplyComments, {
      payload: {parentId},
      fetchKey: parentId,
      isFirst,
    }),
  addEpisodeReplyComments: (data: {
    parentId: number;
    replyComments: IComment[];
    isFirst?: boolean;
    isEnd: boolean;
    replyTotalCount: number;
  }) => createAction(ActionType.AddEpisodeReplyComments, data),
  setEpisodeReplyOpen: (commentId: number, isOpen: boolean) =>
    createAction(ActionType.SetEpisodeReplyOpen, {commentId, isOpen}),
  fetchEpisodeLikeStatus: (commentId: number, likeStatus: ICommentLikeStatus) =>
    createActionFetch(ActionType.FetchEpisodeLikeStatus, {
      payload: {commentId, likeStatus},
      fetchKey: commentId,
    }),
  setEpisodeLikeStatus: (commentId: number, likeStatus: ICommentLikeStatus) =>
    createAction(ActionType.SetEpisodeLikeStatus, {commentId, likeStatus}),
  fetchDeleteEpisodeComment: (episodeId: number, commentId: number) =>
    createActionFetch(ActionType.FetchDeleteEpisodeComment, {
      payload: {episodeId, commentId},
    }),
  deleteEpisodeComment: (commentId: number) =>
    createAction(ActionType.DeleteEpisodeComment, {commentId}),
  fetchPostEpisodeComment: (payload: {
    contentId: number;
    episodeId: number;
    content: string;
    isSpoiler: boolean;
  }) => createActionFetch(ActionType.FetchPostEpisodeComment, {payload}),
  fetchPostEpisodeReplyComment: (payload: {
    contentId: number;
    episodeId: number;
    parentId: number;
    content: string;
  }) =>
    createActionFetch(ActionType.FetchPostEpisodeReplyComment, {
      payload,
    }),
  setEpisodeCommentSort: (sort: ICommentSort) =>
    createAction(ActionType.SetEpisodeCommentSort, {sort}),

  fetchContentComments: (
    payload: {
      contentId: number;
      sort: ICommentSort;
    },
    isFirst?: boolean
  ) =>
    createActionFetch(ActionType.FetchContentComments, {
      payload,
      fetchKey: payload.contentId,
      isFirst,
    }),
  addContentComments: (data: {
    contentId: number;
    comments: IComment[];
    isFirst?: boolean;
    sort: ICommentSort;
  }) => createAction(ActionType.AddContentComments, data),
  fetchContentReplyComments: (
    payload: {
      contentId: number;
      parentId: number;
    },
    isFirst?: boolean
  ) =>
    createActionFetch(ActionType.FetchContentReplyComments, {
      payload,
      fetchKey: payload.parentId,
      isFirst,
    }),
  addContentReplyComments: (data: {
    contentId: number;
    parentId: number;
    replyComments: IComment[];
    isFirst?: boolean;
    isEnd: boolean;
    replyTotalCount: number;
  }) => createAction(ActionType.AddContentReplyComments, data),
  setContentReplyOpen: (data: {
    contentId: number;
    commentId: number;
    isOpen: boolean;
  }) => createAction(ActionType.SetContentReplyOpen, data),
  fetchContentLikeStatus: (payload: {
    contentId: number;
    commentId: number;
    likeStatus: ICommentLikeStatus;
  }) =>
    createActionFetch(ActionType.FetchContentLikeStatus, {
      payload,
      fetchKey: payload.commentId,
    }),
  setContentLikeStatus: (data: {
    contentId: number;
    commentId: number;
    likeStatus: ICommentLikeStatus;
  }) => createAction(ActionType.SetContentLikeStatus, data),
  fetchDeleteContentComment: (contentId: number, commentId: number) =>
    createActionFetch(ActionType.FetchDeleteContentComment, {
      payload: {contentId, commentId},
    }),
  deleteContentComment: (contentId: number, commentId: number) =>
    createAction(ActionType.DeleteContentComment, {contentId, commentId}),
  setContentCommentSort: (contentId: number, sort: ICommentSort) =>
    createAction(ActionType.SetContentCommentSort, {contentId, sort}),

  fetchEventComments: (
    payload: {
      eventId: number;
      sort: ICommentSort;
    },
    isFirst?: boolean
  ) =>
    createActionFetch(ActionType.FetchEventComments, {
      payload,
      fetchKey: payload.eventId,
      isFirst,
    }),
  addEventComments: (data: {
    comments: IComment[];
    isFirst?: boolean;
    sort: ICommentSort;
  }) => createAction(ActionType.AddEventComments, data),
  fetchEventReplyComments: (parentId: number, isFirst?: boolean) =>
    createActionFetch(ActionType.FetchEventReplyComments, {
      payload: {parentId},
      fetchKey: parentId,
      isFirst,
    }),
  addEventReplyComments: (data: {
    parentId: number;
    replyComments: IComment[];
    isFirst?: boolean;
    isEnd: boolean;
    replyTotalCount: number;
  }) => createAction(ActionType.AddEventReplyComments, data),
  setEventReplyOpen: (commentId: number, isOpen: boolean) =>
    createAction(ActionType.SetEventReplyOpen, {commentId, isOpen}),
  fetchEventLikeStatus: (commentId: number, likeStatus: ICommentLikeStatus) =>
    createActionFetch(ActionType.FetchEventLikeStatus, {
      payload: {commentId, likeStatus},
      fetchKey: commentId,
    }),
  setEventLikeStatus: (commentId: number, likeStatus: ICommentLikeStatus) =>
    createAction(ActionType.SetEventLikeStatus, {commentId, likeStatus}),
  fetchDeleteEventComment: (eventId: number, commentId: number) =>
    createActionFetch(ActionType.FetchDeleteEventComment, {
      payload: {eventId, commentId},
    }),
  deleteEventComment: (commentId: number) =>
    createAction(ActionType.DeleteEventComment, {commentId}),
  fetchPostEventComment: (payload: {
    eventId: number;
    content: string;
    isSpoiler: boolean;
  }) => createActionFetch(ActionType.FetchPostEventComment, {payload}),
  fetchPostEventReplyComment: (payload: {
    eventId: number;
    parentId: number;
    content: string;
  }) =>
    createActionFetch(ActionType.FetchPostEventReplyComment, {
      payload,
    }),
  setEventCommentSort: (sort: ICommentSort) =>
    createAction(ActionType.SetEventCommentSort, {sort}),

  fetchReportComment: (payload: {
    commentId: number;
    reportType: ReportType;
    etcText?: string;
    onSuccess: (url?: string) => void;
  }) => createActionFetch(ActionType.FetchReportComment, {payload}),
  fetchBlockWriter: (commentId: number, contentId?: number) =>
    createActionFetch(ActionType.FetchBlockWriter, {
      payload: {commentId, contentId},
    }),
  fetchUnBlockWriter: (commentId: number, contentId?: number) =>
    createActionFetch(ActionType.FetchUnBlockWriter, {
      payload: {commentId, contentId},
    }),
  setBlockComment: (userId: string, isBlock: boolean, contentId?: number) =>
    createAction(ActionType.SetWriterBlock, {userId, isBlock, contentId}),
};
